import * as React from 'react'
import { observer, inject } from 'mobx-react'
import Form, { ISubmitEvent, IChangeEvent } from 'react-jsonschema-form'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import {
    getQuestionnaireFormUIScheme,
    getEventQuestionnaireFormScheme,
    getQuestionnaireCreditExpertFormUIScheme,
    getQuestionnaireFormScheme,
    Questionnaire,
    QuestionnaireStatus,
    transformErrors,
    validate,
    getQuestionnaireCallerFormUIScheme,
    getQuestionnaireReadonlyFormUIScheme,
} from '../../../Model/Questionnaire'
import { Button } from 'react-bootstrap'
import { action } from 'mobx'
import { history } from '../../../Routing'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import AffiliatesStore from '../../../Stores/AffiliatesStore'
import { Affiliate } from '../../../Model/AffiliateModel'
import DateTimeHelper from '../../../Helpers/DateTimeHelper'
import * as _ from 'lodash'
import ActionsLocalService from '../../../Services/ActionsLocalService'

export interface IQuestionnaireFormProps {
    questionnaire: Questionnaire,
    className?: string,
    localizationStore?: LocalizationStore,
    userStore?: UserStore,
    creditDetails?: boolean,
    hideSave?: boolean
    hideClone?: boolean
    hideCheck: boolean
    affiliatesStore?: AffiliatesStore
    actionsLocalService?: ActionsLocalService
}

@inject('localizationStore')
@inject('userStore')
@inject('affiliatesStore')
@inject('actionsLocalService')
@observer
export default class QuestionnaireForm extends React.Component<IQuestionnaireFormProps> {

    constructor(props: any) {
        super(props)
    }

    @action.bound
    createOrUpdate(e: ISubmitEvent<any>): void {
        var formDataRequest: any

        formDataRequest = Object.assign(e.formData, formDataRequest)
        let bDay = DateTimeHelper.parseFromListToMoment(formDataRequest['client']['birthday'])
        e.formData.affiliate.id = e.formData.affiliate.affiliateList.affiliateId
        formDataRequest['client']['birthday'] = bDay ? bDay!.format() : ''

        delete formDataRequest['createDate']
        delete formDataRequest['updateDate']
        delete formDataRequest['credit']['createDate']
        delete formDataRequest['credit']['updateDate']
        delete formDataRequest['credit']['courtDecision']
        // Moment(formDataRequest['client']['birthday'], 'DD.MM.YYYY').utc().format()
        let q = JSON.parse(JSON.stringify(formDataRequest))
        
        if (q.status && q.id) {
            HttpActionsService.getInstance().updateQuestionnaire(q)
        } else {
            HttpActionsService.getInstance().createQuestionnaire(q)
        }
    }

    clone(e: any, q: Questionnaire) {
        QuestionnairesStore.getInstance().setClonedItem(q)
        history.push('/questionnaire')
    }

    getUISchema(affiliates: Array<Affiliate>) {
        let { questionnaire } = this.props
        const us = UserStore.getInstance()

        if (!questionnaire) {
            return
        }

        let schema =
            (!questionnaire.status && questionnaire.status !== 0)
                || questionnaire.status === QuestionnaireStatus.InProgressCreditConsultant
                || us.checkAdmin 
                || us.checkCreditGroupAdministrator
                || us.checkSuperAdmin
                ? getQuestionnaireFormUIScheme(affiliates)
                : getQuestionnaireReadonlyFormUIScheme()

        if (us.checkCreditExpert && QuestionnaireStatus.ActiveCredit === questionnaire.status) {
            schema = getQuestionnaireCreditExpertFormUIScheme(affiliates)
        } else if (us.checkCaller || us.checkCollector || us.checkCollectionGroupAdministrator || us.checkHardCaller) {
            schema = getQuestionnaireCallerFormUIScheme(affiliates)
        }

        return schema
    }

    getScheme(questionnaire: Questionnaire, affiliates: Array<Affiliate>): any {
        return !!this.props.creditDetails ?
            getEventQuestionnaireFormScheme(questionnaire, affiliates) :
            getQuestionnaireFormScheme(questionnaire, affiliates)
    }

    difference(a: any, b: any) {
        function changes(x: any, y: any) {
            return _.transform(x, function (result: any, value: any, key: any) {
                if (!_.isEqual(value, y[key])) {
                    result[key] = (_.isObject(value) && _.isObject(y[key])) ? changes(value, y[key]) : value
                }
            })
        }
        return changes(a, b)
    }

    @action.bound
    onChange(e: IChangeEvent<Questionnaire>) {
        try {
            const { questionnaire } = this.props
            let diff = this.difference(questionnaire, e.formData)

            if (Object.keys(diff).length > 0) {
                e.formData = Object.assign(questionnaire, e.formData)
                this.props.actionsLocalService!.updateQ(e.formData)
            }
        } catch (ex) {
            console.error(ex)
        }
    }

    render() {
        const self = this
        let { localizationStore, questionnaire, affiliatesStore } = this.props

        if (!questionnaire || !questionnaire.id) {
            questionnaire = QuestionnairesStore.getInstance().getItem
        }

        let affiliates = affiliatesStore!.getList

        return (
            <div className={this.props.className}>
                <Form
                    schema={this.getScheme(questionnaire, affiliates)}
                    uiSchema={this.getUISchema(affiliates)}
                    onSubmit={(e) => self.createOrUpdate(e)}
                    formData={questionnaire!}
                    validate={validate}
                    transformErrors={transformErrors}
                    onChange={self.onChange}
                >
                    <div className="questionnaireBtns">
                        <Button
                            hidden={this.props.hideSave}
                            type="submit"
                        >
                            {localizationStore!.t!('Save')}
                        </Button>
                        <Button
                            className="clone"
                            hidden={this.props.hideClone}
                            type="button"
                            onClick={(e) => { self.clone(e, questionnaire) }}
                        >
                            {localizationStore!.t!('Clone')}
                        </Button>
                        <Button
                            type="button"
                            hidden={this.props.hideCheck}
                            onClick={(e) => history.push('/externalCheck/' + questionnaire.id)}
                        >
                            {localizationStore!.t!('Check')}
                        </Button>
                    </div>
                </Form>
                {/* <ExternalCheckGovDataForm questionnaire={questionnaire!} /> */}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireForm.tsx